import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.664 1.332v.667h4.667v1.333H8.664v9.333h2.667V14H4.664v-1.334h2.667V3.332H2.664V1.999h4.667v-.667zM3.331 4.227l1.885 1.886a2.667 2.667 0 1 1-3.771 0zm9.333 0 1.886 1.886a2.667 2.667 0 1 1-3.771 0zM3.331 6.113l-.943.943a1.333 1.333 0 1 0 1.886 0zm9.333 0-.943.943a1.333 1.333 0 1 0 1.886 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }